/** Per-page interface transitions. No cookie, account key or form contents. */
export type SigninInterface = "email_capture" | "oauth";
export type InterfaceReason = "initial" | "sign_in_anyway" | "viewport_change";

export class SigninInterfaceRecorder {
  private last: Option<SigninInterface> = null;
  private sequence = 0;
  private readonly pageId = crypto.randomUUID().replaceAll("-", "");

  record(value: SigninInterface, reason: InterfaceReason): void {
    if (this.last === value || this.sequence >= 1000) return;
    const body = JSON.stringify({ interface: value, reason: this.last == null ? "initial" : reason,
      page_id: this.pageId, sequence: ++this.sequence });
    this.last = value;
    // The endpoint shares the normal server-derived request context. It must
    // never accept a browser-supplied identity, campaign or timestamp.
    void fetch("/api/funnel/signin-interface", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body, credentials: "same-origin", keepalive: true,
    }).catch(() => { /* Best-effort exposure; never block sign-in. */ });
  }
}
